module.exports = __webpack_public_path__ + "static/media/about.1dfc2e93.jpg";